function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 368 371"
}, props), React.createElement("rect", {
  width: "231.892",
  height: "56.246",
  rx: "28.123",
  transform: "matrix(.93816 -.3462 .33787 .9412 101.116 290.829)",
  fill: "#F1F4FA"
}), React.createElement("rect", {
  width: "371.027",
  height: "56.246",
  rx: "28.123",
  transform: "matrix(.93816 -.3462 .33787 .9412 .177 273.969)",
  fill: "#F1F4FA"
}), React.createElement("rect", {
  width: "278.271",
  height: "56.246",
  rx: "28.123",
  transform: "matrix(.93816 -.3462 .33787 .9412 22.403 207.358)",
  fill: "#F1F4FA"
}), React.createElement("rect", {
  width: "315.373",
  height: "56.246",
  rx: "28.123",
  transform: "matrix(.93816 -.3462 .33787 .9412 26.104 146.967)",
  fill: "#F1F4FA"
}), React.createElement("rect", {
  width: "185.514",
  height: "56.246",
  rx: "28.123",
  transform: "matrix(.93816 -.3462 .33787 .9412 55.742 79.474)",
  fill: "#F1F4FA"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M64.3 284.702c3.878 0 7.02-3.187 7.02-7.118 0-3.931-3.142-7.117-7.02-7.117-3.876 0-7.019 3.186-7.019 7.117s3.143 7.118 7.02 7.118zm0-1.899c2.844 0 5.149-2.337 5.149-5.219 0-2.883-2.305-5.22-5.148-5.22-2.843 0-5.148 2.337-5.148 5.22 0 2.882 2.305 5.219 5.148 5.219zM80.196 174.38c2.908 0 5.265-2.39 5.265-5.338s-2.357-5.338-5.265-5.338c-2.908 0-5.265 2.39-5.265 5.338s2.357 5.338 5.265 5.338zm-.002-1.422c2.133 0 3.861-1.753 3.861-3.915s-1.728-3.914-3.86-3.914c-2.133 0-3.861 1.752-3.861 3.914s1.728 3.915 3.86 3.915zM279.202 83.127c3.325 0 6.02-2.732 6.02-6.103 0-3.37-2.695-6.103-6.02-6.103-3.325 0-6.02 2.732-6.02 6.103 0 3.37 2.695 6.103 6.02 6.103zm-.003-1.628c2.438 0 4.415-2.004 4.415-4.476s-1.977-4.476-4.415-4.476c-2.438 0-4.414 2.004-4.414 4.476s1.976 4.476 4.414 4.476zM128.353 83.549c3.835 0 6.945-3.153 6.945-7.042 0-3.89-3.11-7.042-6.945-7.042-3.836 0-6.946 3.153-6.946 7.042s3.11 7.042 6.946 7.042zm-.002-1.88c2.813 0 5.093-2.312 5.093-5.164s-2.28-5.164-5.093-5.164-5.093 2.312-5.093 5.164 2.28 5.164 5.093 5.164zM305.89 235.505c2.557 0 4.63-2.101 4.63-4.694s-2.073-4.695-4.63-4.695-4.63 2.102-4.63 4.695c0 2.593 2.073 4.694 4.63 4.694zm.004-1.879c1.534 0 2.778-1.261 2.778-2.817 0-1.555-1.244-2.817-2.778-2.817-1.535 0-2.778 1.262-2.778 2.817 0 1.556 1.243 2.817 2.778 2.817z",
  fill: "#283451"
}), React.createElement("path", {
  d: "M249.617 178c0 35.626-28.643 64.5-63.968 64.5S121.68 213.626 121.68 178c0-35.626 28.644-64.5 63.969-64.5s63.968 28.874 63.968 64.5z",
  fill: "#fff",
  stroke: "#000"
}), React.createElement("path", {
  d: "M149.943 178.867L175.73 205l51.575-56",
  stroke: "#000",
  strokeWidth: "4",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));